module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "stripe-logo.a44609bf.png";